import { render, staticRenderFns } from "./addAndEdit.vue?vue&type=template&id=6b39d9d0&"
import script from "./addAndEdit.vue?vue&type=script&lang=js&"
export * from "./addAndEdit.vue?vue&type=script&lang=js&"
import style0 from "./addAndEdit.vue?vue&type=style&index=0&id=6b39d9d0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports